import http from "../../backend/http.js";

async function getTask(id) {
  try {
    const response = await http.get(`crm/tasks/${id}`);
    return {
      id: response.data.id,
      title: response.data.title,
      creator: response.data.creator != null ? { id: response.data.creator.id, title: response.data.creator.title } : null,
      date: response.data.date,
      implementer: response.data.implementer != null ? { id: response.data.implementer.id, title: response.data.implementer.title } : null,
      status: response.data.status,
      type: response.data.type,
      planDate: response.data.planDate,
      description: response.data.description,
      agreement: response.data.agreement != null ? { id: response.data.agreement.id, title: response.data.agreement.title } : null,
    };
  } catch (err) {
    throw err;
  }
}

async function updateTask(id, type) {
  try {
    const response = await http.put(`crm/tasks/${id}`, type);
    return response;
  } catch (err) {
    throw err;
  }
}

async function createTask(type) {
  try {
    const response = await http.post("crm/tasks", type);
    return response;
  } catch (err) {
    throw err;
  }
}

async function getTasks(
    page = 1,
    rowsPerPage = 9,
    search = "",
    filter = ""
) {
  try {
    const queryFilter = `&filter.status=${
      filter.taskStatusFilter.id
    }&filter.agreementId=${
      filter.taskAgreementFilter ? filter.taskAgreementFilter.id : null
    }&filter.implementerId=${
      filter.taskImplementerFilter ? filter.taskImplementerFilter.id : null
    }`;

    const response = await http.get(
      `crm/tasks?page=${page}&pageSize=${rowsPerPage}&searchTerm=${search}${queryFilter}`
    );

    return response.data;
  } catch (err) {
    throw err;
  }
}

async function selectTasks(
    page = 1,
    rowsPerPage = 9,
    search = ""
) {
  try {
    const response = await http.get(
      "crm/tasks/references", {
        params: {
          page,
          pageSize: rowsPerPage,
          searchTerm: search,
        },
      }
    );
    return response.data;
  } catch (err) {
    throw err;
  }
}

export { getTask, updateTask, getTasks, createTask, selectTasks };